/**
 * VITIS Mobile Menu
 * Menu mobile moderno con navigazione a pannelli
 */

(function() {
  'use strict';

  // Elementi DOM
  const backdrop = document.getElementById('vmm-backdrop');
  const panel = document.getElementById('vmm-panel');
  const mainPanel = document.getElementById('vmm-main-panel');
  const subPanel = document.getElementById('vmm-sub-panel');
  const closeBtn = document.getElementById('vmm-close');
  const closeSubBtn = document.getElementById('vmm-close-sub');
  const backBtn = document.getElementById('vmm-back');
  const categoryName = document.getElementById('vmm-category-name');
  const subcategoriesContainer = document.getElementById('vmm-subcategories-container');
  const categoryButtons = document.querySelectorAll('.vmm-category-btn');

  // Stato
  let isOpen = false;

  // Cart sync cache
  let cartCache = null;
  let cartCacheTimestamp = 0;
  const CART_CACHE_TTL = 5000; // 5 seconds

  /**
   * Sincronizza il conteggio carrello nel menu mobile
   */
  function syncCartCount() {
    var now = Date.now();
    
    // Check cache validity
    if (cartCache !== null && (now - cartCacheTimestamp) < CART_CACHE_TTL) {
      updateCartUI(cartCache);
      return;
    }

    // Fetch fresh cart data
    fetch('/cart.js', {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' }
    })
    .then(function(response) {
      return response.json();
    })
    .then(function(cart) {
      cartCache = cart.item_count;
      cartCacheTimestamp = Date.now();
      updateCartUI(cart.item_count);
    })
    .catch(function(err) {
      console.warn('[VMM] Cart sync failed:', err);
    });
  }

  /**
   * Aggiorna il conteggio carrello nell'UI
   */
  function updateCartUI(count) {
    var cartCountEls = document.querySelectorAll('.vmm-cart-count');
    cartCountEls.forEach(function(el) {
      el.textContent = count;
    });
  }

  /**
   * Apre il menu mobile
   */
  function openMenu() {
    isOpen = true;
    backdrop.classList.add('is-open');
    panel.classList.add('is-open');
    document.body.classList.add('vmm-open');
    
    // Sync cart count on open
    syncCartCount();
    
    // Focus trap
    panel.setAttribute('aria-hidden', 'false');
    closeBtn.focus();
  }

  /**
   * Chiude il menu mobile
   */
  function closeMenu() {
    isOpen = false;
    backdrop.classList.remove('is-open');
    panel.classList.remove('is-open');
    document.body.classList.remove('vmm-open');
    
    // Reset ai pannelli principali
    mainPanel.classList.remove('is-hidden');
    subPanel.classList.remove('is-active');
    
    panel.setAttribute('aria-hidden', 'true');
  }

  /**
   * Mostra le sottocategorie di una categoria
   */
  function showSubcategories(categoryHandle, title) {
    // Trova le sottocategorie corrispondenti
    const subcategoriesEl = document.querySelector('.vmm-subcategories[data-subcategories="' + categoryHandle + '"]');
    
    if (subcategoriesEl) {
      // Aggiorna il titolo
      categoryName.textContent = title;
      
      // Clona le sottocategorie nel pannello
      subcategoriesContainer.innerHTML = subcategoriesEl.innerHTML;
      
      // Anima i pannelli
      mainPanel.classList.add('is-hidden');
      subPanel.classList.add('is-active');
    }
  }

  /**
   * Torna al menu principale
   */
  function goBack() {
    mainPanel.classList.remove('is-hidden');
    subPanel.classList.remove('is-active');
  }

  /**
   * Gestisce la pressione dei tasti
   */
  function handleKeydown(e) {
    if (!isOpen) return;
    
    if (e.key === 'Escape') {
      closeMenu();
    }
  }

  // Event Listeners
  if (backdrop) {
    backdrop.addEventListener('click', closeMenu);
  }

  if (closeBtn) {
    closeBtn.addEventListener('click', closeMenu);
  }

  if (closeSubBtn) {
    closeSubBtn.addEventListener('click', closeMenu);
  }

  if (backBtn) {
    backBtn.addEventListener('click', goBack);
  }

  // Bottoni categoria
  categoryButtons.forEach(function(btn) {
    btn.addEventListener('click', function() {
      var handle = btn.getAttribute('data-category');
      var title = btn.getAttribute('data-category-title');
      showSubcategories(handle, title);
    });
  });

  // Keyboard events
  document.addEventListener('keydown', handleKeydown);

  // Chiudi menu quando si clicca su un link
  if (panel) {
    panel.querySelectorAll('a').forEach(function(link) {
      link.addEventListener('click', function() {
        setTimeout(closeMenu, 100);
      });
    });
  }

  // Esponi funzione per aprire il menu globalmente
  window.vitisMobileMenu = {
    open: openMenu,
    close: closeMenu,
    toggle: function() {
      isOpen ? closeMenu() : openMenu();
    },
    invalidateCartCache: function() {
      cartCache = null;
      cartCacheTimestamp = 0;
    }
  };

  // Listen for cart changes to invalidate cache
  document.addEventListener('cart:change', function() {
    cartCache = null;
    cartCacheTimestamp = 0;
  });

  // Auto-collegamento al pulsante hamburger esistente
  document.addEventListener('DOMContentLoaded', function() {
    var hamburgerButtons = document.querySelectorAll('[aria-controls="header-sidebar-menu"], .kom-menu');
    
    hamburgerButtons.forEach(function(btn) {
      var newBtn = btn.cloneNode(true);
      btn.parentNode.replaceChild(newBtn, btn);
      
      newBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        window.vitisMobileMenu.toggle();
      });
    });
  });

})();


